var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEvaluationFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7917 7.46668C13.4417 7.46668 13.2 7.46668 13.2 7.46668C13.6833 5.98335 14.2167 3.59165 12.5583 2.64165C12.1083 2.38332 10.7583 1.97498 10.5667 2.74165C10.3 3.79165 10.0417 4.84165 9.41667 5.76665C8.9 6.52498 8.11666 7.36668 7.14166 7.46668C7.14166 7.50835 7.14166 7.55834 7.14166 7.55834V15.2667C7.14166 15.2667 7.14166 15.475 7.14166 15.6833C7.24166 15.7167 7.34166 15.75 7.34166 15.75L9.09167 16.325C9.66667 16.5167 10.2667 16.6167 10.875 16.6167H15.15C16 16.6167 16.6917 15.9333 16.6917 15.0917C16.6917 14.8917 16.65 14.7083 16.575 14.5333C17.2333 14.35 17.7083 13.7583 17.7083 13.0583C17.7083 12.6667 17.5667 12.3083 17.3167 12.0333C17.5583 11.7667 17.7083 11.4083 17.7083 11.025C17.7083 10.6333 17.5667 10.275 17.3167 10C17.5583 9.73333 17.7083 9.37498 17.7083 8.99165C17.7083 8.14998 17.0167 7.46668 16.175 7.46668C16.175 7.46668 14.6583 7.46668 13.7917 7.46668Z",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29163 6.14996H5.19996C6.26662 6.14996 7.13329 7.01664 7.13329 8.0833V15.7833C7.13329 16.85 6.26662 17.7166 5.19996 17.7166H2.29163V6.14996Z",
    stroke: "#49454F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71653 15.6166C5.07552 15.6166 5.36653 15.3257 5.36653 14.9667C5.36653 14.6077 5.07552 14.3167 4.71653 14.3167C4.35755 14.3167 4.06653 14.6077 4.06653 14.9667C4.06653 15.3257 4.35755 15.6166 4.71653 15.6166Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEvaluationFeedback);
export default __webpack_public_path__ + "static/media/ic_evaluation_feedback.0779192e100e0bb0f1597317c0dffca7.svg";
export { ForwardRef as ReactComponent };